import Vue from 'vue'
import Vuex from 'vuex'

import { Loading,  QSpinnerFacebook,  } from 'quasar'
import { Notify } from 'quasar'





// import 'quill/dist/quill.core.css'
// import 'quill/dist/quill.snow.css'
// import 'quill/dist/quill.bubble.css'
 
// import Quill from 'quill'; 

// import { quillEditor } from 'vue-quill-editor-next'
// import ImageResize from 'quill-image-resize-module'
// import QuillBetterTable from 'quill-better-table'

// Quill.register('modules/imageResize', ImageResize)
// Quill.register({
//   'modules/better-table': QuillBetterTable
// }, true)


var toolbarOptions = [
      ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
      ['blockquote', 'code-block'],

      [{ 'header': 1 }, { 'header': 2 }],               // custom button values
      [{ 'list': 'ordered'}, { 'list': 'bullet' }],
      [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
      [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
      [{ 'direction': 'rtl' }],                         // text direction

      [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
      [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
      [ 'link', 'image', 'video', 'formula' ],          // add's image support
      [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
      [{ 'font': [] }],
      [{ 'align': [] }],

      ['clean']                                         // remove formatting button
  ];











const URL_APP = 'https://serversumaku.konaweselatankab.go.id/';
// const URL_APP = 'https://sumaku.konaweselatankab.com/';
// const URL_APP = 'https://serversumaku.konaweselatankab.go.id/';
// const URL_APP = 'https://server.sumaku.konaweselatankab.go.id/';



Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    coordinat : {
      lat:-4.034694, 
      lng: 122.484263
    },
    btn : {
      add : false,
      edit : false,
      remove : false,
    },
    url : {
      URL_APP : URL_APP,
    
      office_borang_acu : URL_APP+'api/v1/office_borang_acu/',
      office_m_jenisSurat : URL_APP+'api/v1/m_jenisSurat/',
      office_m_bentukSurat : URL_APP+'api/v1/m_bentukSurat/',
      office_m_sifatSurat : URL_APP+'api/v1/m_sifatSurat/',
      office_m_unit_kerja : URL_APP+'api/v1/m_unitKerja/',
      office_m_bioData : URL_APP+'api/v1/m_bioData/',

      office_sk_agendaSurat : URL_APP+'api/v1/sk_agendaSurat/',
      office_sk_konsepSurat : URL_APP+'api/v1/sk_konsepSurat/',
      office_sk_penandatangananSurat : URL_APP+'api/v1/sk_penandatangananSurat/',
      office_sk_verifikasiSurat : URL_APP+'api/v1/sk_verifikasiSurat/',

      office_sm_agendaSurat : URL_APP+'api/v1/sm_agendaSurat/',
      office_sm_verifikasiDisposisi : URL_APP+'api/v1/sm_verifikasiDisposisi/',
      office_sm_disposisi : URL_APP+'api/v1/sm_disposisi/',
      office_sm_laporanDisposisi : URL_APP+'api/v1/sm_laporanDisposisi/',
     

      office_ConvertPDF : URL_APP+'api/v1/converSuratToPage/',





      URL_MasterKategori : URL_APP+'/api/v1/dataMasterkategoriAbsen/',
      URL_historyData : URL_APP+'api/v1/historyData/',


      checkAuth : URL_APP+'api/v1/checkAuth/',
    
    },

    nama : "RISWAN",

    list_jenis : [],
    list_bentuk : [],
    list_sifat : [],
    list_borang : [],

    list_unit_kerja_auto : [],
    list_unit_kerja_search : [],
    list_biodata_auto : [],


    unit_kerja : '',

    page_first: 1,
    page_last: 0,
    cari_value: "",
    cek_load_data : true,


    quill : '',
    content : '',



    list_contoh : [
      {id : 1, uraian : 'Uraian 1'},
      {id : 2, uraian : 'Uraian 2'},
      {id : 3, uraian : 'Uraian 3'},
    ]

    
  },



  mutations: {

    getStorage(state){
      var get_profile = JSON.parse(localStorage.profile);
      state.unit_kerja = get_profile.profile.unit_kerja; 
    },
    shoWLoading(){
      const spinner = typeof QSpinnerFacebook !== 'undefined'
        ? QSpinnerFacebook // Non-UMD, imported above
        : Quasar.components.QSpinnerFacebook // eslint-disable-line


      Loading.show({
        spinner,
        spinnerColor: 'yellow',
        spinnerSize: 140,
        backgroundColor: 'purple',
        // message: 'Loading... Tunggu beberapa saat, system sedang menyesuaikan akun anda..!',
        // messageColor: 'white'
      })
    },
    hideLoading(){
      Loading.hide()
    },
    shoWNotify(state, message, color, icon){
      Notify.create({
        message: message,
        color: color,
        position : 'top-right',
        icon:icon
      })
    },




    addEditor() {
      setTimeout(() => {


        new FroalaEditor('textarea#editor', {
          placeholderText: 'Mulai menuliskan sesuatu..',
          height: 720,
          zIndex: 8000,
          tabSpaces: 4,
          indentMargin: 10,
          attribution: false,
          imageUpload: true,
          imageDefaultAlign: 'left',
          // imageDefaultDisplay: 'inline-block',
          imageAllowedTypes: ['jpeg', 'jpg', 'png'],
          imageMaxSize: 5 * 1024 * 1024,
          tableStyles: {
            class1: 'Alternate Rows',
            class2: 'Dashed Borders',
            class3: 'No Border'
          },
          // imageManagerLoadURL: "http://localhost:5010/images/",
          tableColors: [
            '#61BD6D', '#1ABC9C', '#54ACD2', '#2C82C9', '#9365B8', '#475577', '#CCCCCC',
            '#41A85F', '#00A885', '#3D8EB9', '#2969B0', '#553982', '#28324E', '#000000',
            '#F7DA64', '#FBA026', '#EB6B56', '#E25041', '#A38F84', '#EFEFEF', '#FFFFFF',
            '#FAC51C', '#F37934', '#D14841', '#B8312F', '#7C706B', '#D1D5D8', 'REMOVE'
          ],
          events: {
            "image.beforeUpload": function (files) {
              var editor = this;
              console.log('image di pangggil')

              if (files.length) {
                var reader = new FileReader();
                reader.onload = function (e) {
                  var result = e.target.result;
                  editor.image.insert(result, null, null, editor.image.get());
                };
                reader.readAsDataURL(files[0]);
              }
              editor.popups.hideAll();




              // var formData = new FormData();

              // formData.append("file", files[0]);
              // fetch(this.$store.state.url.URL_ADM_CAPAIAN_KEGIATAN + "addFoto", {
              //   method: "POST",
              //   headers: {
              //     // "content-type": "application/json",
              //     authorization: "kikensbatara " + localStorage.token
              //   },
              //   body: formData
              // }).then(res_data => {

              // });












              return false;
            }
          }






        })
      }, 50);

    },


    addQuill(state, idxx) {
      // setTimeout(() => {
      //   state.quill = new Quill(idxx, {
      //     modules: {
      //       imageResize: true,
      //       table: false,
      //       'better-table': {
      //         operationMenu: {
      //           items: {
      //             unmergeCells: {
      //               text: 'Another unmerge cells name'
      //             }
      //           },
      //           color: {
      //             colors: ['green', 'red', 'yellow', 'blue', 'white'],
      //             text: 'Background Colors:'
      //           }
      //         }
      //       },
      //       keyboard: {
      //         bindings: QuillBetterTable.keyboardBindings
      //       },
      //       toolbar: toolbarOptions,
      //     },
      //     theme: 'snow'
      //   });


      // }, 55);


    },


    addQuillTable(state, idxx){
      // let quill = state.quill
      // let tableModule = quill.getModule('better-table');
      // tableModule.insertTable(3, 3)
    },

    getQuillcontent(state, idxx){
      // var data = state.quill
      // var ht = data.root.innerHTML;
      // state.content = ht
    }
  },






  actions: {
  },
  modules: {
  }
})
